import { backendRequest } from '../api'
import { faGem, faStopwatch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useEffect } from 'react'
import Loader from '../all/loader'
import { useNavigate } from 'react-router-dom'


const OfferModal = ({ user, setShow }) => {

    const history = useNavigate();
    const redirectToPage = (url) => history("/" + url);

    return (
        <>
            <div className='offer-modal' onClick={(e) => { setShow(false) }}>
                <div className='offer-container' onClick={(e) => e.stopPropagation()}>
                    <p className='close' onClick={(e) => { setShow(false) }}>x</p>

                    <div className='modal-header'>
                        <p className='title'>BUFF.GAME</p>
                        <button>Open Offer</button>
                    </div>

                    <div className='offer-card'>
                        <div className='offer-image'>
                            <img src='https://main-p.agmcdn.com/offers/24203-JhXD7gPM.jpg' />
                        </div>
                        <div className='offer-details'>
                            <div className='offer-tags'>
                               <div className='offer-reward'>
                                    1000
                                    <span className='blue'><FontAwesomeIcon icon={faGem} /></span>
                                </div> 
                                <div className='offer-provider'>Adgem</div>
                            </div>
                            <p className='offer-description'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                        </div>
                    </div>

                </div>
            </div >

            <style jsx>
                {`
                    .offer-card {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr; /* 3 equal columns */
                        gap: 16px;
                        background: #21294d;
                        border-radius: 6px;
                        cursor: pointer;
                    }
                    .offer-image {
                        aspect-ratio: 1 / 1;
                        width: 100%;
                        overflow: hidden;
                        border-radius: 6px;
                    }

                    .offer-image img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 6px;
                    }

                    .offer-details {
                        grid-column: span 2;
                        height: 100%;
                    }

                    .offer-description {
                        margin: 0px;
                        padding: 0px;
                        line-height: 1.3;
                        color: #9CA4BF;
                        font-size: 14px;
                    }

                    .offer-reward {
                        background: #141a31;
                        font-size: 12px;
                        padding: 2px 5px;
                        border-radius: 6px;
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        color: #9CA4BF;
                    }

                    .offer-provider {
                        background: #7288dc;
                        font-size: 12px;
                        padding: 2px 5px;
                        border-radius: 6px;
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        color: white;
                    }

                    .offer-tags {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        margin-bottom: 10px;
                    }

                    @media only screen and (max-width: 1024px) {
                        .offer-container {
                            overflow: scroll;
                            overflow-y: auto;
                            max-height: 90vh;
                            margin-top: 3rem;
                            margin-bottom: 6rem;
                            overflow-y: scroll !important;
                        }
                    }

                    .modal-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .modal-header button {
                        border: unset;
                        outline: unset;
                        color: white;
                        background-color: #4DAEFF;
                        border-radius: 6px;
                        padding: 2px 10px;
                        cursor: pointer;
                        font-size: 14px;
                    }

                    .offer-ad {
                        background-color: #262E58;

                        border-radius: 8px;
                        box-shadow: 0 3px 10px rgb(0,0,0,0.2);
                        width: 100%;
                        height: 9rem;
                        padding: 12px;
                        box-sizing: border-box;

                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .offer-header h4 {
                        margin-block: 0;
                        margin-bottom: 2px;
                    }

                    .offer-header p {
                        letter-spacing: -0.025em;
                        color: rgb(156, 164, 191);
                        font-size: 0.75rem;
                        line-height: 1rem;
                    }

                    .offer-footer {
                        margin-top: 0.8rem;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .offer-footer .timer {
                        display: flex;
                        align-items: center;
                        color: #F1C475;
                    }

                    .offer-footer .timer p {
                        margin-left: 4px;
                        font-size: 0.95rem;
                    }

                    .view {
                        border: unset;
                        outline: unset;
                        cursor: pointer;
                        border-radius: 4px;
                        font-weight: 600;                      
                        width: 7rem;
                        height: 30px;
                        background-color: #4D3A4B;
                        transition: all 0.3s;
                        transition: transform 0.05s;
                        color: #F1C475;
                    }

                    .view:hover {
                        background-color: #5d4b5b;
                    }

                    .offer-modal {
                        position: fixed;
                        height: 100%;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(0,0,0,0.3);
                        z-index: 1001;
                        top: 0;
                        left: 0;
                    }

                    @media only screen and (max-width: 1024px) {
                        .offer-modal {
                            padding: 12px;
                        }
                    }

                    .title {
                        font-size: 16px;
                        font-weight: 500;
                        color: #F1C475;
                    }

                    .offer-container {
                        position: relative;
                        height: fit-content;
                        width: 600px;
                        background: #21294D;
                        border-radius: 8px;

                        position: relative;

                        display: flex;
                        flex-direction: column;

                        padding: 24px;
                        box-sizing: border-box;
                        gap: 12px;

                        overflow: hidden;
                    }

                    @media only screen and (min-width: 1024px) {
                        .offer-container {
                            height: auto !important;
                        }
                    }

                    .close {
                        font-weight: 700;
                        font-size: 12px;
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        cursor: pointer;
                    }

                    p {
                        margin: unset;
                    }
                `}
            </style>
        </>
    )
}

export default OfferModal